import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'custom-message',
  templateUrl: './custom-message.component.html',
  styleUrls: ['./custom-message.component.scss']
})
export class CustomMessageComponent implements OnInit {

    errorMessage: string = "";
    successMessage: string = "";
    infoMessage: string = "";
    displayErrors: boolean = false;
    displaySuccesses: boolean = false;
    displayInformation: boolean = false;
    isPopupOpened: boolean = false;

    constructor(public sharedService: SharedService) {
    
    }

    ngOnInit(): void {

      this.sharedService.showErrorMessage.subscribe(
        (data: any ) => { 
          this.errorMessage = data.error, 
          this.displayErrors = data.displayError 
        }
      );
      this.sharedService.showSuccessMessage.subscribe(
        (data: any ) => { this.successMessage = data.success, this.displaySuccesses = data.displaySuccess }
      );
      this.sharedService.showInfoMessage.subscribe(
        (data: any ) => { this.infoMessage = data.success, this.displayInformation = data.displayInfo }
      );

     
        this.sharedService.isPopupOpened.subscribe(
          (data: any ) => { 
            setTimeout(() => {
            this.isPopupOpened = data.isPopupOpened ;
          }, 100);
          }
        );
  
     
    }

    ngOnDestroy() {
        this.resetValues();
    }

    cancelClick() {
      this.resetValues();
    }

    resetValues() {
      this.sharedService.showErrorMessage.emit({error: "", displayError: false});
      this.sharedService.showSuccessMessage.emit({success: "",displaySuccess: false});
      this.sharedService.showInfoMessage.emit({info: "",displayInfo: false});
    }
}